import {gql} from '@apollo/client';

const GetCountriesCostYears = gql`
  query GetCountriesCostYears {
    countriesCostYears {
      countryId
      years
    }
  }
`;

export default GetCountriesCostYears;
